module.exports = __webpack_public_path__ + "img/seating.8a60b149.png";